import { Link } from "react-router-dom";
import { TriangleAlert } from "lucide-react";

export const CalibrationBanner = ({ programmed, target }) => (
  <div data-testid="calibration-banner" className="flex flex-wrap items-center justify-between gap-3 border border-amber-400/40 bg-amber-400/5 px-4 py-2 font-mono text-xs uppercase tracking-widest text-amber-300">
    <span className="flex items-center gap-2">
      <TriangleAlert size={14} /> Calibration mode // <span data-testid="calibration-count">{programmed}/{target}</span> specimens programmed - the site opens once the vocabulary is sealed
    </span>
    <Link data-testid="calibration-setup-link" to="/setup" className="underline underline-offset-4 hover:text-amber-100 transition-colors">Open bench</Link>
  </div>
);
